import React from 'react';
import { ChevronRight, Check } from 'lucide-react';

export interface StepperStep {
  id: string;
  title: string;
  description: string;
  completed: boolean;
  active: boolean;
}

interface StepperProps {
  steps: StepperStep[];
  onStepClick?: (stepId: string) => void;
  onboardingStep?: number;
}

const Stepper: React.FC<StepperProps> = ({ steps, onStepClick, onboardingStep = 4 }) => {
  const renderStepGroup = (groupSteps: StepperStep[], startIndex: number) => (
    <>
      {groupSteps.map((step, groupIndex) => {
        const absoluteIndex = startIndex + groupIndex;
        return (
          <React.Fragment key={step.id}>
            <div
              className={`stepper-step ${step.active ? 'active' : ''} ${step.completed ? 'completed' : ''} ${
                onboardingStep === 2 && step.id === 'selection' ? 'onboarding-blink' : ''
              }`}
              onClick={() => onStepClick?.(step.id)}
            >
              <div className="step-indicator">
                {step.completed ? (
                  <Check size={16} />
                ) : (
                  <span className="step-number">{absoluteIndex + 1}</span>
                )}
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>

            {groupIndex < groupSteps.length - 1 && (
              <div className="step-connector">
                <ChevronRight size={20} />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </>
  );

  return (
    <div className="stepper-container">
      <div className="stepper-header">
        <h2>Strategy Builder</h2>
        <p>Build your multi-asset strategy step by step</p>
      </div>

      <div className="stepper-groups">
        <div className="stepper-group">
          <div className="stepper-group-label">Strategy Definition</div>
          <div className="stepper-steps">
            {renderStepGroup(steps, 0)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
